<template>
  <div>
    <div class="container">
      <p class='title'>用电基本信息</p>
      <el-row>
        <el-col :span="8">
          <span class="label">用电单位：</span>{{info.eleUnit}}
        </el-col>
        <el-col :span="8">
          <span class="label">最大需求量：</span>{{info.maxDemand}}
        </el-col>
        <el-col :span="8">
          <span class="label">客户售电套餐:</span>{{info.setMeals}}
        </el-col>
        <!-- <el-col :span="8">
          <span class="label">客户编号：</span>{{info.clientNumber}}
        </el-col> -->
        <el-col :span="8">
          <span class="label">投运日期：</span>{{info.commissionDate}}
        </el-col>
        <el-col :span="8">
          <span class="label">用电性质：</span>{{info.eleNature}}
        </el-col>
        <el-col :span="8">
          <span class="label">客户用电编号：</span>{{info.clientEleNumber}}
        </el-col>
        <el-col :span="8">
          <span class="label">电价行业类别：</span><span v-show="info.elePriceType==1">居民生活用电</span>
          <span v-show="info.elePriceType==2">大工业用电</span>
          <span v-show="info.elePriceType==3">一般工商业用电</span>
          <span v-show="info.elePriceType==4">非工业用电</span>
          <span v-show="info.elePriceType==5">农业生产用电</span>
        </el-col>
        <el-col :span="8">
          <span class="label">用电地址：</span>{{info.eleAddress}}
        </el-col>
        <el-col :span="8">
          <span class="label">客户电压等级：</span>
          <span v-show="info.volLevel==1">不满1kV</span>
          <span v-show="info.volLevel==2">1-10kV</span>
          <span v-show="info.volLevel==3">35kV</span>
          <span v-show="info.volLevel==4">11kV</span>
          <span v-show="info.volLevel==5">110kV</span>
          <span v-show="info.volLevel==6">220kV及以上</span>
        </el-col>
      </el-row>
    </div>
    <div class="ax_default line"></div>
    <div class="container">
      <div class="header">
        <p class="title">客户用电量</p>
        <div style="justify-content: flex-end;display:flex">
          <el-upload class="upload-demo"
                     action
                     :show-file-list="false"
                     v-if="show($store.state.menuList.ydxxlist,'import')"
                     :http-request="uploadfile">
            <el-button type="primary">导入</el-button>
          </el-upload>
          <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.ydxxlist,'export')"
                     @click="exportMethod('https://c.cesc-energy.com/service/client/consumption/export/'+id,'用电信息.xlsx')">导出数据</el-button>
          <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.ydxxlist,'exportT')"
                     @click="exportMethod('https://c.cesc-energy.com/service/client/consumption/export/template/'+id,'用电信息.xlsx')">导出模板</el-button>
          <el-button type="primary"
                     style="margin-left:20px"
                     v-if="show($store.state.menuList.ydxxlist,'add')"
                     @click="dialogFormVisible=true">新增</el-button>
        </div>
      </div>
      <el-row>
        <el-table border
                  ref="multipleTable"
                  :data="tableData.slice((current-1)*10,current*10)"
                  @selection-change="handleSelectionChange"
                  tooltip-effect="dark"
                  style="width: 100%">
          <el-table-column type="selection"
                           width="100">
          </el-table-column>
          <el-table-column label="年份"
                           width="200">
            <template slot-scope="scope">{{ scope.row.year }}</template>
          </el-table-column>
          <el-table-column prop="eleQuantity"
                           label="用电量(kwh)">
          </el-table-column>
          <el-table-column prop="address"
                           label="操作"
                           width="200"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)"
                         v-if="show($store.state.menuList.ydxxlist,'edit')"
                         type="text"
                         size="small">编辑</el-button>
              <el-button type="text"
                         size="small"
                         v-if="show($store.state.menuList.ydxxlist,'delete')"
                         @click="deleteTable(scope.$index, tableData,scope.row.eleConsumptionId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px"
             v-if="show($store.state.menuList.ydxxlist,'deletes')">
          <el-checkbox v-model="checked"
                       @change="toggleAllSelection">全选</el-checkbox>
          <el-button @click="deleteTables"
                     style="margin-left:20px"
                     type="danger">批量删除</el-button>
          <div class="pagination">
            <el-pagination @current-change="handleCurrentChange"
                           :current-page="current"
                           :page-size="10"
                           background
                           layout="total, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </el-row>
    </div>
    <el-dialog title="新增客户用电量"
               :visible.sync="dialogFormVisible"
               style="width:1000px;margin:auto">
      <el-form :model="form"
               ref="form"
               label-width="120px">
        <el-form-item label="年份">
          <el-input v-model="form.year"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用电量(kWh)">
          <el-input v-model="form.eleQuantity"
                    autocomplete="off"
                    oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label-width="0"
                      style="text-align:center">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button @click="submitForm('form')"
                     type="primary">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="编辑客户用电量"
               :visible.sync="dialogFormVisible1"
               style="width:1000px;margin:auto">
      <el-form :model="form1"
               ref="form1"
               label-width="120px">
        <el-form-item label="年份">
          <el-input v-model="form1.year"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用电量(kWh)">
          <el-input v-model="form1.eleQuantity"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label-width="0"
                      style="text-align:center">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button @click="submitForm1('form1')"
                     type="primary">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getEleInfo, postconsumption, putconsumption, deleteconsumption, getmenusubmenu, deletesClientEleInfo, postClientConsumptionFile } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      checked: false,
      tableData: [],
      total: 0,
      current: 1,
      id: localStorage.getItem('id'),
      info: {},
      dialogFormVisible: false,
      dialogFormVisible1: false,
      multipleSelection: [],
      form: {
        year: '',
        eleQuantity: ''
      },
      form1: {
        year: null,
        eleQuantity: null
      }
    }
  },
  created () {
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
    if (this.$store.state.parantId.parantId) {
      getmenusubmenu(this.$store.state.parantId.parantId).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'ydxxlist', data: res.data })
        }
      })
    }
    this.init()
  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'ydxxlist', data: res.data })
        }
      })
    },
  },
  methods: {
    show,
    exportMethod,
    init () {
      getEleInfo(localStorage.getItem('id')).then(res => {
        if (res.code === 0) {
          this.info = res.data.clientEleInfo ? res.data.clientEleInfo : {}
          this.tableData = res.data.eleConsumptionList
          this.total = res.data.eleConsumptionList.length
          localStorage.setItem('ydxx', JSON.stringify(res.data.clientEleInfo))
          localStorage.setItem('eleInfoId', res.data.clientEleInfo ? res.data.clientEleInfo.eleInfoId : '')
        }
      })
    },
    uploadfile (item) {
      let fileObj = item.file
      let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postClientConsumptionFile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
        else {
          this.$message({
            message: '导入失败',
            type: 'error'
          });
        }
      })
    },
    handleCurrentChange (val) {
      this.current = val
    },
    onSubmit () {
      let params = {
        current: this.current
      }
      getEleInfo(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    deleteTable (index, rows, consumptionId) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteconsumption(consumptionId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].eleConsumptionId)
        }
        deletesClientEleInfo(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.current = 1,
              this.init()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleClick (row) {
      this.dialogFormVisible1 = true,
        this.form1 = row
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.clientId = localStorage.getItem('id')
          postconsumption(this.null2str(this.form)).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
            }
            this.dialogFormVisible = false
            this.form = {}
            this.$refs[formName].resetFields();
            this.init()
          })
        } else {
          return false;
        }
      });
    },
    submitForm1 (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form1.clientId = localStorage.getItem('id')
          putconsumption(this.null2str(this.form1)).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
            }
            this.dialogFormVisible1 = false
          })
        } else {
          return false;
        }
      });
    },
    null2str (data) {
      for (let x in data) {
        if (data[x] === null) { // 如果是null 把直接内容转为 ''
          data[x] = '';
        } else {
          if (Array.isArray(data[x])) { // 是数组遍历数组 递归继续处理
            data[x] = data[x].map(z => {
              return this.null2str(z);
            });
          }
          if (typeof (data[x]) === 'object') { // 是json 递归继续处理
            data[x] = this.null2str(data[x])
          }
        }
      }
      return data;
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
  border: none;
}
.header {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
.title {
  margin: 10px 0;
  color: #666;
}
.text {
  font-weight: 650;
  font-style: normal;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#999;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.el-col {
  height: 40px;
  align-content: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
}
</style>